import jwtDecode from 'jwt-decode';
import { SessionState } from '../store/session.slice';
import { JwtPayload } from '@families-link/shared';
import { JwtPayloadWithRole } from '../interfaces/token-with-payload.interface';

export const createTokenPair = (access: string | null, refresh: string | null): SessionState => {
	try {
		if (!access || !refresh) {
			return {
				access: null,
				refresh: null
			};
		}

		const accessPayload = jwtDecode<JwtPayloadWithRole>(access);
		const refreshPayload = jwtDecode<JwtPayloadWithRole>(refresh);

		return {
			access: {
				token: access,
				payload: accessPayload
			},
			refresh: {
				token: refresh,
				payload: refreshPayload
			}
		};
	} catch {
		return {
			access: null,
			refresh: null
		};
	}
};
